import { baseUrl } from "../../../config.js";

export default {
  props: {
    items: [Object, Array],
  },
  /*
      Defines the data used by the component
    */
  data() {
    return {
      mySpace: 0,
      loaded: false,
      link: "",
      successend: false,
      copied: false,
      emails: "",
      sender: "",
      transfer: 0,
      company: this.$store.state.company,
      user: this.$store.state.user,
      error: false,
      showCopy: false,
    };
  },
  created() {
    this.setLinkAndTransfer();

    setTimeout(() => {
      if (this.$refs.emails) {
        this.$refs.emails.focus();
      }
    }, 300);
  },
  computed: {
    emailsArray: function () {
      if (this.emails === "") {
        return [];
      }
      return this.emails.split(",");
    },
  },
  methods: {
    setLinkAndTransfer() {
      const formData = new FormData();

      if (Array.isArray(this.items)) {
        //is array
        const files = [];
        const folders = [];

        this.items.forEach((item) => {
          if (item.extension) {
            //is file
            files.push(item.id);
          } else {
            //is folder
            folders.push(item.id);
          }
        });

        formData.append("files", JSON.stringify(files));
        formData.append("folders", JSON.stringify(folders));
      } else if (this.items.collectionId) {
        formData.append("collection", this.items.collectionId);
      } else {
        //is one item
        formData.append(
          this.items.extension ? "files" : "folders",
          JSON.stringify([this.items.id])
        );
        //add empty value for server
        formData.append(
          !this.items.extension ? "files" : "folders",
          JSON.stringify([])
        );
        this.mySpace =
          this.items.myspace !== undefined ? this.items.myspace : 0;
      }

      formData.append("myspace", this.mySpace);

      //add transfer data
      this.$axios
        .post(
          `${baseUrl}${
            this.items.collectionId ? "/collectiontransfer" : "/transferadd"
          }`,
          formData
        )
        .then((r) => {
          this.loaded = true;
          this.link = r.data.link;
          this.transfer = r.data.transfer;
        });
    },
    reset() {
      this.loaded = true;
      this.emails = "";
      this.sender = "";
      this.successend = false;
      this.copied = false;
      this.showCopy = false;
    },
    sendTransfer() {
      this.error = false;

      let formData = new FormData();

      formData.append("emails", this.emails);
      formData.append("sender", this.sender);
      formData.append("transfer", this.transfer);
      formData.append("myspace", this.mySpace);

      this.$axios.post(baseUrl + "/transfersend", formData).then((response) => {
        if (
          response.data.success == false &&
          response.data.msg == "email_invalid"
        ) {
          this.error = true;
        }
        if (
          response.data.success == true &&
          response.data.msg == "transfer_send"
        ) {
          this.successend = true;
        }
      });
    },
  },
};
